import React from "react";

import ThemeFocus from "../../focus/focus_theme";

const SearchThemes = ({ dataList, focus, search, setSearch }) => {
  const mode = { editable: false, display: "all" };
  return (
    <ThemeFocus
      themes={dataList}
      focus={focus}
      notify={() => {}}
      mode={mode}
      search={search}
      setSearch={setSearch}
    />
  );
};

export default SearchThemes;
